import { motion } from "framer-motion";

export const FlowRail = ({ items = [], notes = [], icons = [], tone = "dark", testId = "flow-rail" }) => {
  const dark = tone === "dark";
  const card = dark ? "bg-ink-2/90 border-white/10 text-white" : "bg-white border-ink/10 text-ink";
  const note = dark ? "text-[#AEB7D3]" : "text-ink/70";
  return (
    <div className="relative" data-testid={testId}>
      <div className={`pointer-events-none absolute left-[12.5%] right-[12.5%] top-[38px] hidden h-px lg:block ${dark ? "bg-white/15" : "bg-ink/15"}`}>
        <span className="absolute top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 animate-rail-x rounded-full bg-leaf shadow-[0_0_18px_4px_rgba(140,198,63,.6)]" />
      </div>
      <div className={`pointer-events-none absolute bottom-10 left-[38px] top-10 w-px lg:hidden ${dark ? "bg-white/15" : "bg-ink/15"}`}>
        <span className="absolute left-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 animate-rail-y rounded-full bg-leaf shadow-[0_0_18px_4px_rgba(140,198,63,.6)]" />
      </div>
      <ol className="relative grid gap-4 lg:grid-cols-4 lg:gap-6">
        {items.map((label, i) => {
          const Icon = icons[i];
          const last = i === items.length - 1;
          return (
            <motion.li
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.2, 0.8, 0.2, 1] }}
              className="flex items-start gap-4 lg:flex-col lg:items-center lg:text-center"
              data-testid={`${testId}-item-${i}`}
            >
              <span
                className={`relative z-10 grid h-[76px] w-[76px] shrink-0 place-items-center rounded-full border ${
                  last ? "border-leaf bg-leaf text-ink" : card
                }`}
              >
                {Icon && <Icon className="h-7 w-7" strokeWidth={1.6} />}
                {last && <span className="absolute inset-0 animate-pulse-ring rounded-full border border-leaf" />}
              </span>
              <div className="pt-2 lg:pt-1">
                <span className={`font-mono text-xs ${dark ? "text-leaf" : "text-leaf-deep"}`}>0{i + 1}</span>
                <p className="mt-1 font-display text-xl font-semibold uppercase leading-tight tracking-tight sm:text-2xl">{label}</p>
                {notes[i] && <p className={`mt-1.5 text-sm ${note}`}>{notes[i]}</p>}
              </div>
            </motion.li>
          );
        })}
      </ol>
    </div>
  );
};
